var RemoveTopicCommand = require('./remove-topic');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
    },
    write : function(output, req) {
        Codec.writeString(output, req.selector.expression);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/remove-topic/remove-topic-serialiser.js
// module id = 1040
// module chunks = 1